module.exports = __webpack_public_path__ + "img/2_41.e9c7eed1.png";